import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import store from './store'
import { observer } from 'mobx-react'
import columns from './columns'
import ncolumns from './ncolumns'
import { toJS } from 'mobx'
import { Table, Modal, Input } from 'hljd'
import { toTimestamp } from '@hlj/hlj-utils'
import { JUKE_PATH_A } from '@constant'

const { TextArea } = Input
const Search = Input.Search

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      params: { id },
      location: {
        query: { type }
      }
    } = props
    store.id = id
    store.type = type
  }

  componentDidMount() {
    store.getList()
    store.getPayView()
  }

  render() {
    let header = [
      <a style={{ color: '#333' }} href={JUKE_PATH_A}>
        聚客宝
      </a>,
      <a style={{ color: '#333' }} href={`${JUKE_PATH_A}/old`}>
        旧版聚客宝
      </a>,
      '报名信息'
    ]

    const {
      pagination,
      list,
      activity: {
        title,
        sign_up_end_time,
        draw_status,
        sign_up_count,
        is_pay,
        pay_type,
        actual_bought_phones,
        create_point
      },
      type,
      balance,
      remark,
      remarkVisible,
      d,
      h,
      m,
      s,
      searchVal,
      luckStatus,
      presentStatus
    } = store

    let search = (
      <Search
        placeholder="输入用户姓名或手机号"
        style={{ width: 200 }}
        value={searchVal}
        onChange={store.changeSearchVal}
        onSearch={store.contentSearch}
        onPressEnter={store.contentSearch}
      />
    )

    return (
      <HeaderView title="报名信息" header={header} extra={search}>
        <div className={styles.box}>
          <div className={styles.abstract}>
            <div style={{ marginBottom: 10 }}>
              <span className={styles.title}>{title}</span>
              {toTimestamp() < toTimestamp(sign_up_end_time) ? (
                <div className={styles.status}>
                  <span>报名进行中 </span>
                  {type == 'nlimit' && (
                    <span>
                      <span style={{ color: '#ff705e' }}>
                        {d}天 {h}小时 {m}分钟 {s}秒{' '}
                      </span>后报名结束
                    </span>
                  )}
                  {type == 'limit' && (
                    <span>
                      <span style={{ color: '#ff705e' }}>
                        {d}天 {h}小时 {m}分钟 {s}秒{' '}
                      </span>后开始抽奖
                    </span>
                  )}
                </div>
              ) : (
                <div className={styles.status}>
                  {type == 'nlimit' && <span>报名已结束</span>}
                  {type == 'limit' &&
                    draw_status == 1 && <span>抽奖结果已公布</span>}
                  {type == 'limit' &&
                    draw_status == 0 && <span>报名已结束</span>}
                </div>
              )}
            </div>
            <div>
              <span style={{ fontSize: 18, color: '#ff705e' }}>
                {sign_up_count}
              </span>人已报名
              {balance == 0 && (
                <span>
                  {(pay_type == 0 ||
                    pay_type == 1 ||
                    (pay_type == 2 &&
                      parseInt(actual_bought_phones) >=
                        parseInt(create_point))) && (
                    <span
                      style={{
                        color: '#ff8c47',
                        fontSize: 12,
                        paddingLeft: 10
                      }}
                    >
                      活动点不足，新报名用户通知及联系已暂停
                    </span>
                  )}
                  {/* <a href="" className={styles.toCharge}>
                    立即充值
                  </a> */}
                </span>
              )}
            </div>
          </div>

          {is_pay == 1 &&
            balance != 0 && (
              <div className={styles.success}>
                <img src="http://qnm.hunliji.com/o_1b4achfoj1gqu70d15031k6u1k9p7.png" />
                <div>
                  <p>活动购买成功</p>
                  <p>
                    *请珍惜每次与用户交流的机会，优秀的商家可将90%的活动用户发展成消费客户
                  </p>
                </div>
              </div>
            )}

          <Table
            style={{ marginTop: 20 }}
            dataSource={toJS(list)}
            columns={
              type == 'limit'
                ? columns(luckStatus, draw_status)
                : ncolumns(presentStatus, draw_status)
            }
            pagination={pagination}
            onChange={store.setPage}
            rowKey={record => record.id}
          />
        </div>

        <Modal
          title="备注"
          visible={remarkVisible}
          closable={false}
          onOk={store.addRemark}
          onCancel={store.hideRemarkModal}
        >
          <TextArea rows={4} value={remark} onChange={store.changeRemark} />
        </Modal>
      </HeaderView>
    )
  }
}
